import './PillTag.css';

export function PillTag({ children, tone = 'default', className }) {
  const cls = ['ui-pill-tag', `ui-pill-tag--${tone}`, className].filter(Boolean).join(' ');
  return <span className={cls}>{children}</span>;
}
